(() => {
  const navigationItems = [
    { id: "gti-overview", label: "Overview" },
    { id: "gti-colours", label: "Colours" },
    { id: "gti-models", label: "Models" },
    { id: "gti-available", label: "Available now" },
    { id: "gti-film", label: "Film" },
  ];

  function addHeroContent(hero) {
    hero.classList.add("gti-hero");
    if (!hero.querySelector(".gti-hero__content")) {
      hero.insertAdjacentHTML(
        "beforeend",
        `<div class="gti-hero__content">
          <p class="gti-eyebrow">Designed in Perth / Made in Indonesia</p>
          <h1>GTI</h1>
          <p class="gti-hero__statement">Built for now.<br>Made to be played.</p>
          <div class="gti-hero__actions">
            <a href="/collections/gti">Shop available GTI</a>
            <a href="#gti-overview">Discover the range</a>
          </div>
        </div>`,
      );
    }
  }

  function buildNavigation(hero) {
    const nav = document.createElement("nav");
    nav.className = "gti-page-nav";
    nav.setAttribute("aria-label", "GTI page sections");
    nav.innerHTML = `<div class="gti-page-nav__inner">
      ${navigationItems.map((item) => `<a href="#${item.id}">${item.label}</a>`).join("")}
    </div>`;
    hero.after(nav);
    return nav;
  }

  function structureOverview(overview) {
    overview.id = "gti-overview";
    overview.classList.add("gti-overview");
    const card = overview.querySelector(".bg-card");
    const layout = overview.querySelector(".flex-layout");
    if (!card || !layout || card.querySelector(".gti-feature-rail")) return;

    const rail = document.createElement("ul");
    rail.className = "gti-feature-rail";
    rail.innerHTML = `
      <li><span>01</span>Stainless steel frets</li>
      <li><span>02</span>Ormsby-spec pickups</li>
      <li><span>03</span>Australian quality control</li>
    `;
    layout.before(rail);
  }

  function structureColourLab(section) {
    section.id = "gti-colours";
    section.classList.add("gti-colour-lab");
    if (!section.querySelector(".gti-colour-lab__heading")) {
      section.insertAdjacentHTML(
        "afterbegin",
        `<header class="gti-colour-lab__heading">
          <div>
            <p class="gti-eyebrow">Colour lab</p>
            <h2>FIND YOUR<br>FINISH.</h2>
          </div>
          <p>Select a model, then explore every available solid colour and exotic top.</p>
        </header>`,
      );
    }

    section.querySelectorAll(".slideshow__slide").forEach((slide) => {
      const title = slide.querySelector(".banner__heading")?.textContent.trim() || "GTI";
      const names = [...slide.querySelectorAll(".guitar-color-name span")];
      slide.querySelectorAll(".guitar-image").forEach((image, index) => {
        const colour = names[index]?.textContent.trim();
        if (!image.alt) image.alt = `${colour || ""} ${title} guitar`.trim();
      });
      slide.querySelectorAll(".color-button").forEach((button) => {
        button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Colore /, "Colour "));
      });
    });

    section.addEventListener("click", (event) => {
      const button = event.target.closest(".color-button");
      if (!button) return;
      const colour = button.style.backgroundColor;
      const channels = colour.match(/\d+/g)?.map(Number) || [0, 0, 0];
      const brightness = channels[0] * 0.299 + channels[1] * 0.587 + channels[2] * 0.114;
      section.style.setProperty("--selected-colour", colour);
      section.style.setProperty("--selected-text-colour", brightness > 165 ? "#111" : "#fff");
    });
  }

  function observeSections(nav) {
    if (!("IntersectionObserver" in window)) return;
    const links = [...nav.querySelectorAll("a")];
    const sections = navigationItems.map((item) => document.getElementById(item.id)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        links.forEach((link) => {
          const isCurrent = link.hash === `#${visible.target.id}`;
          link.classList.toggle("is-active", isCurrent);
          if (isCurrent) link.setAttribute("aria-current", "location");
          else link.removeAttribute("aria-current");
        });
      },
      { rootMargin: "-20% 0px -65% 0px", threshold: [0, 0.1, 0.35] },
    );
    sections.forEach((section) => observer.observe(section));
  }

  function initializeGtiPage() {
    const main = document.querySelector(".template-page-gti #MainContent");
    if (!main || main.dataset.gtiInitialized === "true") return;

    const hero = main.querySelector('[id*="slideshow_fbtD84"]');
    const overviewSection = main.querySelector('[id*="ormsby_text_GWiTEP"]');
    const colourSection = main.querySelector('[id*="guitar_slider_FWaxrM"]');
    const modelsSection = main.querySelector('[id*="ormsby_text_B9G6T7"]');
    const availabilitySection = main.querySelector('[id*="ormsby_text_rBthFg"]');
    const collectionSection = main.querySelector('[id*="featured_collection_CfzdFV"]');
    const filmSection = main.querySelector('[id*="video_VmxCpN"]');
    if (!hero || !overviewSection || !colourSection || !modelsSection) return;

    main.dataset.gtiInitialized = "true";
    addHeroContent(hero);

    const overview = overviewSection.querySelector(".ormsby-section-container");
    const models = modelsSection.querySelector(".ormsby-section-container");
    const availability = availabilitySection?.querySelector(".ormsby-section-container");
    structureOverview(overview);
    structureColourLab(colourSection);

    models.id = "gti-models";
    models.classList.add("gti-models");
    if (availability) availability.classList.add("gti-stock-message");
    if (collectionSection) {
      collectionSection.id = "gti-available";
      collectionSection.classList.add("gti-available");
    }
    if (filmSection) {
      filmSection.id = "gti-film";
      filmSection.classList.add("gti-film");
    }

    const nav = buildNavigation(hero);
    observeSections(nav);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeGtiPage);
  } else {
    initializeGtiPage();
  }

  document.addEventListener("shopify:section:load", () => {
    const main = document.querySelector(".template-page-gti #MainContent");
    if (main) delete main.dataset.gtiInitialized;
    initializeGtiPage();
  });
})();
